import { render, staticRenderFns } from "./carousel-pages.vue?vue&type=template&id=ccba3bee&scoped=true&"
import script from "./carousel-pages.vue?vue&type=script&lang=js&"
export * from "./carousel-pages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccba3bee",
  null
  
)

export default component.exports